import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Row, Col, Button, Label, Container } from "reactstrap";
import DataWrapper from '../../../principal/containers/DataWrapper';
import ContainersDetalhesStore from "../stores/ContainersDetalhesStore";
import ContainersDetalhesDadosGerais from '../components/ContainersDetalhesDadosGerais';
import ContainersDetalhesMovimentacoes from '../components/ContainersDetalhesMovimentacoes';
import ContainersDetalhesDUE from '../components/ContainersDetalhesDUE';
import ContainersDetalhesLacre from '../components/ContainersDetalhesLacre';
import { IconeNavio, IconeCaminhao, IconeCarregar } from '../../../comum/components/Icones';
import ContainersLista from '../../../comum/components/ContainersLista';
import Footer from "../../../comum/components/Footer";
import Timeline from "../../../comum/components/Timeline"
import { formataParaDiaMesAno, formataParaHoraMinSeg } from '../../../../utils/formatar';
import moment from 'moment';
import { observable } from 'mobx';

import ModalAviso from '../../../comum/components/ModalAviso'
import FooterContent from './../../../comum/components/FooterContent';
import FooterOptions from '../../../comum/components/FooterOptions';
import IconButton from '../../../comum/components/IconButton';

@inject("store")
@DataWrapper
@observer
export class ContainersDetalhes extends Component {

    @observable loading;
    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        //Controle para o Booking
        this.codigoContainer = _.get(this.props.location.state, `codigoContainer`);
        this.entradaCntr = _.get(this.props.location.state, `entradaCntr`);
        this.codigoBooking = _.get(this.props.location.state, `codigoBooking`);
        this.operacaoBooking = _.get(this.props.location.state, `operacaoBooking`);

        //Controles para Container
        this.booking = _.get(this.props.location.state, `booking`);
        this.container = _.get(this.props.location.state, `container`);
        this.notaFiscal = _.get(this.props.location.state, `notaFiscal`);

        this.filtros = {};
        this.filtros.container = this.container;
        this.filtros.booking = this.booking;
        this.filtros.notaFiscal = this.notaFiscal;

        this.loading = false;
        this.controller = new ContainersDetalhesStore(this.props.match.params.id, this.entradaCntr);
    }

    componentDidMount() {
        this.controller.detalhar()
    }

    // https://reactjs.org/docs/react-component.html#unsafe_componentwillupdate
    componentWillUpdate() {
        const status = <Label className="situacao-btn">{this.controller.dadosContainer.Status}</Label>;
        this.tituloPaginaStore.setTituloEStatus(this.controller.dadosContainer.Cntr, status);
        this.appStore.showTopbar(true);
        let params = {};
        if (this.codigoContainer) {
            params.state = {
                ...params.state,
                codigoBooking: this.codigoBooking
            }
            this.appStore.showVoltarTopBar(true, '/booking', params);
        }
        else if (this.container || this.booking || this.notaFiscal) {
            params.state = {
                ...params.state,
                container: this.container,
                booking: this.booking,
                notafiscal: this.notaFiscal
            }
            this.appStore.showVoltarTopBar(true, '/containers', params);
        }
        else {
            this.appStore.showVoltarTopBar(true, '/containers');
        }
    }

    quadro = () => {
        if (this.controller.dadosContainer.Categoria) {
            if (this.controller.dadosContainer.Categoria === "IMPORTAÇÃO" || this.controller.dadosContainer.Categoria === "EXPORTAÇÃO") {
                this.loading = false;
                return <div className="containers--timelines">
                    {verifyCategory(this.controller.dadosContainer)}
                    {this.controller.dadosContainer.VeicPlaca &&
                        <React.Fragment>
                            <ul className="page-title-with-button">
                                <li>
                                    <h1>Veículo
                                            <Label className={this.controller.dadosContainer.VeicStatus ? "situacao-btn" : ""}>
                                            {this.controller.dadosContainer.VeicStatus}
                                        </Label>
                                    </h1>
                                </li>
                            </ul>
                            {this.controller.dadosContainer.VeicPlaca && <Timeline
                                name={this.controller.dadosContainer.VeicPlaca}
                                image={<IconeCaminhao tamanho="lg" />}
                                information={veicData(this.controller.dadosContainer, !process.env.rig)}
                            />}

                        </React.Fragment>
                    }
                </div>;
            }
        }
        else {
            return <div> <IconeCarregar tamanho="2x" /></div>
        }
    }

    renderDetalhes = () => 
    {
        const lista =
            <div className="containers--lista">
                {<ContainersLista controller={this.controller} gkeyContainerAtivo={this.controller.gkeyContainerAtivo} />}
            </div>

        const dadosGerais =
            <div>
                {<ContainersDetalhesDadosGerais dadosContainer={this.controller.dadosContainer} filtros={this.filtros} />}
            </div>

        const movimentacoes =
            <div>
                {<ContainersDetalhesMovimentacoes dadosContainer={this.controller.dadosContainer} />}
            </div>

        const due =
            <div>
                {<ContainersDetalhesDUE dadosContainer={this.controller.dadosContainer} dados={this.controller.dadosDUE} listaDados={this.controller.listaDadosDue} />}
            </div>

        const lacre =
            <div>
                {<ContainersDetalhesLacre dados={this.controller.dadosContainer} />}
            </div>
        return (
                <div>
                    <div className="form-wrapper">
                        <div className={"content-panel"}>
                            <Container fluid className="containers">
                                {lista}
                                <Row>
                                    <Col xs={12} sm={4} lg={3} xl={3} className="containers-timeline">
                                        {this.quadro()}
                                    </Col>

                                    <Col xs={12} sm={8} lg={9} xl={9} className="containers-infos">
                                        <div>
                                            {dadosGerais}
                                            {movimentacoes}
                                            {this.controller.dadosContainer.Status !== 'VAZIO'
                                                && this.controller.dadosContainer.Categoria === "EXPORTAÇÃO"
                                                && due}
                                            {this.controller.dadosContainer.Status !== 'VAZIO' && lacre}
                                        </div>
                                    </Col>
                                </Row>
                                <div className="containers--info">


                                </div>
                            </Container>
                        </div>
                    </div>
                    <Footer>
                        <FooterOptions>
                        {
                            this.controller.loadingDownloadRelatorio === true
                            ? <IconeCarregar tamanho="2x" />
                            :<div><IconButton
                                icon="file-pdf"
                                text="Baixar PDF"
                                size="md"
                                onClick={this.controller.getRelatorio}
                            /></div>
                        }
                        </FooterOptions>
                    </Footer>
                </div>
        );
    }
    
    modalMensagemErro = () => {
        return (
            this.controller.mensagemErro != "" &&
            <ModalAviso onClickFechar={() => {this.controller.mensagemErro = ""; window.location.replace('/containers')}}>
                <h2>{this.controller.mensagemErro}</h2>
            </ModalAviso>
        );
    }
    
    render() {
        return (!this.controller.mensagemErro ? this.renderDetalhes() : this.modalMensagemErro())
    }
}

function generateDataImport(container_data) {

    const status = process.env.rig ? ["Entrada", "Saída"] : container_data.Desova ? ["Entrada", "Presença de carga", "Recebimento do DAT", "Desova", "Saída"] : ["Entrada", "Presença de carga", "Recebimento do DAT", "Saída"]
    const params = process.env.rig ? ["EntradaData", "SaidaData"] : container_data.Desova ? ["EntradaData", "PresencaCarga", "RecebimentoDat", "Desova", "SaidaData"] : ["EntradaData", "PresencaCarga", "RecebimentoDat", "SaidaData"]

    let selection = []
    status.map((elem, index) => {
        if (container_data[params[index]] === null) {
            selection.push("inactive")
        } else {
            if (moment().isAfter(moment(container_data[params[index]], "DD/MM/YYYY HH:mm:ss")) || moment().isSame(moment(container_data[params[index]], "DD/MM/YYYY HH:mm:ss"))) {
                selection.fill('active', 0, index)
                selection.push("selected")
            } else {
                selection.push("inactive")
            }
        }
    })

    const data = status.map((elem, index) => {
        if (elem === "Saída") {
            return {
                order: index + 1,
                status_name: elem,
                status: selection[index],
                information: container_data[params[index]] && formataParaDiaMesAno(container_data[params[index]]),
                sub_information: container_data[params[index]] && formataParaHoraMinSeg(container_data[params[index]]),
                extra: {
                    status_name: elem,
                    extra_info: container_data.SaidaId,
                    icon: icone(container_data.SaidaModo, "lg")
                }
            }
        } else {
            return {
                order: index + 1,
                status_name: elem,
                status: selection[index],
                information: container_data[params[index]] && formataParaDiaMesAno(container_data[params[index]]),
                sub_information: container_data[params[index]] && formataParaHoraMinSeg(container_data[params[index]])

            }
        }
    })
    return data
}

function generateDataExport(container_data) {


    const status = !process.env.rig && container_data.Status === 'CHEIO' && (!container_data.Subcategoria || container_data.Subcategoria.toUpperCase() !== 'CABOTAGEM') ? ["Entrada", "Recepção da Nota Fiscal", "Liberação", "Saída"] : ["Entrada", "Liberação", "Saída"]
    const params = !process.env.rig && container_data.Status === 'CHEIO' && (!container_data.Subcategoria || container_data.Subcategoria.toUpperCase() !== 'CABOTAGEM') ? ["EntradaData", "RecepcaoNf", "LiberacaoEmbarque", "SaidaData"] : ["EntradaData", "LiberacaoEmbarque", "SaidaData"]


    let selection = []
    status.map((elem, index) => {
        if (container_data[params[index]] === null) {
            selection.push("inactive")
        } else {
            if (moment().isAfter(moment(container_data[params[index]], "DD/MM/YYYY HH:mm:ss")) || moment().isSame(moment(container_data[params[index]], "DD/MM/YYYY HH:mm:ss"))) {
                selection.fill('active', 0, index)
                selection.push("selected")
            } else {
                selection.push("inactive")
            }
        }
    })

    const data = status.map((elem, index) => {
        if (elem === 'Saída') {
            return {
                order: index + 1,
                status_name: elem,
                status: selection[index],
                information: container_data[params[index]] && formataParaDiaMesAno(container_data[params[index]]),
                sub_information: container_data[params[index]] && formataParaHoraMinSeg(container_data[params[index]]),
                extra: {
                    status_name: elem,
                    extra_info: container_data.SaidaId,
                    icon: icone(container_data.SaidaModo, "lg")
                }
            }
        } else {
            return {
                order: index + 1,
                status_name: elem,
                status: selection[index],
                information: container_data[params[index]] && formataParaDiaMesAno(container_data[params[index]]),
                sub_information: container_data[params[index]] && formataParaHoraMinSeg(container_data[params[index]])

            }
        }
    })
    return data
}

function verifyCategory(container_data) {
    switch (container_data.Category) {
        case "EXPRT":
            return <Timeline
                name={`${container_data.EntradaId}`}
                image={icone(container_data.EntradaModo, "lg")}
                information={generateDataExport(container_data)}
            />
        case "IMPRT":
            return <Timeline
                name={`${container_data.EntradaId}`}
                image={icone(container_data.EntradaModo, "lg")}
                information={generateDataImport(container_data)}
            />
        default:
            return null
    }
}

function veicData(container_data, isSSA) {
    const status = isSSA ? ["Triagem", "Liberação", "Entrada", "Atendimento", "Saída"] : ["Entrada", "Saída"]
    const params = isSSA ? ["VeicChegada", "VeicLiberacao", "VeicEntrada", "VeicAtendimento", "VeicSaida"] : ["VeicEntrada", "VeicSaida"]

    let selection = []
    status.map((elem, index) => {
        if (container_data[params[index]] === null) {
            selection.push("inactive")
        } else {
            if (moment().isAfter(moment(container_data[params[index]], "DD/MM/YYYY HH:mm:ss")) || moment().isSame(moment(container_data[params[index]], "DD/MM/YYYY HH:mm:ss"))) {
                selection.fill('active', 0, index)
                selection.push("selected")
            } else {
                selection.push("inactive")
            }
        }
    })

    const data = status.map((elem, index) => {
        return {
            order: index + 1,
            status_name: elem,
            status: selection[index],
            information: container_data[params[index]] && formataParaDiaMesAno(container_data[params[index]]),
            sub_information: container_data[params[index]] && formataParaHoraMinSeg(container_data[params[index]])
        }
    })

    return data

}

function icone(modo, tam) {
    switch (modo) {
        case 'TRUCK':
            return <IconeCaminhao tamanho={tam} />
        case 'VESSEL':
            return <IconeNavio tamanho={tam} />
        default:
            return null
    }
}



// WEBPACK FOOTER //
// ./src/modules/consultas/containers/tela/ContainersDetalhes.js